export default {
  root: ({ props }) => ({
    class: [
      //Size and Shape
      'w-[340px] md:w-96 rounded-md',

      // Positioning
      { '-translate-x-2/4': props.position == 'top-center' || props.position == 'bottom-center' },
    ],
  }),
  message: ({ props }) => ({
    class: [
      'my-4 rounded-md w-full',
      'border-solid border-0 border-l-[6px]',
      'backdrop-blur-[10px] shadow-md',

      // Colors
      {
        'bg-blue-100/70': props.message.severity == 'info',
        'bg-green-100/70': props.message.severity == 'success',
        'bg-orange-100/70': props.message.severity == 'warn',
        'bg-red-100/70': props.message.severity == 'error',
      },
      {
        'border-blue-500': props.message.severity == 'info',
        'border-green-500': props.message.severity == 'success',
        'border-orange-500': props.message.severity == 'warn',
        'border-red-500': props.message.severity == 'error',
      },
      {
        'text-blue-700': props.message.severity == 'info',
        'text-green-700': props.message.severity == 'success',
        'text-orange-700': props.message.severity == 'warn',
        'text-red-700': props.message.severity == 'error',
      },
    ],
  }),
  messageContent: ({ props }) => ({
    class: [
      'flex p-4',
      {
        'items-start': props.message.summary,
        'items-center': !props.message.summary,
      },
    ],
  }),
  messageIcon: {
    class: [
      // Sizing and Spacing
      'w-6 h-6',
      'text-lg leading-none mr-2 shrink-0',
    ],
  },
  messageText: {
    class: [
      // Font and Text
      'text-sm leading-none',
      'ml-2',
      'flex-1',
    ],
  },
  summary: {
    class: 'font-bold block',
  },
  detail: ({ props }) => ({
    class: ['block', 'text-sm', { 'mt-2': props.message.summary }],
  }),
  closebutton: ({ props }) => ({
    class: [
      // Flexbox
      'flex items-center justify-center',

      // Size
      'w-8 h-8',

      // Spacing and Misc
      'ml-auto relative',

      // Shape
      'rounded-full',

      // Colors
      'bg-transparent',

      // Transitions
      'transition duration-200 ease-in-out',

      // States
      'hover:bg-surface-0/50',
      'focus:outline-none focus:outline-offset-0 focus:ring-1',
      {
        'focus:ring-blue-500': props.severity == 'info',
        'focus:ring-green-500': props.severity == 'success',
        'focus:ring-orange-500': props.severity == 'warn',
        'focus:ring-red-500': props.severity == 'error',
      },
      // Misc
      'overflow-hidden',
    ],
  }),
  transition: {
    enterFromClass: 'opacity-0 translate-y-2/4',
    enterActiveClass: 'transition-[transform,opacity] duration-300',
    leaveFromClass: 'max-h-[1000px]',
    leaveActiveClass:
      'transition-[max-height_.45s_cubic-bezier(0,1,0,1),opacity_.3s,margin-bottom_.3s]! overflow-hidden',
    leaveToClass: 'max-h-0 opacity-0 mb-0',
  },
};
